export { default as Maps } from './Map';
export type { ILocation } from './Map';
